import { atom } from 'jotai';
import type { Range } from '@tiptap/core';

export const queryAtom = atom('', (get, set, newValue: string) => {
  set(queryAtom, newValue);
});

export const rangeAtom = atom<Range | null>(null as Range | null);
